import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import * as React from "react";
import {createRef} from "react";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import Avatar from "@material-ui/core/Avatar";
import styled from "styled-components";

let Element = props => {
    let ref = createRef ()

    return <ListItem ref={ ref }
                     id={ "_item" }
                     button
                     selected={ props.selected }
                     onClick={ () => {
                         props.onSelect (props)
                         props.onClose ()
                     } }>
        <ListItemAvatar>
            <DynamicAvatar alt={ props.displayName }
                           src={ props.photo }>{ getAvatar (props.displayName) }</DynamicAvatar>
        </ListItemAvatar>
        <ListItemText
            primary={ <Typography component={ "p" }
                                  variant={ "body2" }>{ props.displayName }</Typography> }
            secondary={ <Typography variant="caption">{ props.mail }</Typography> }
        />
    </ListItem>
}

export default Element;

let DynamicAvatar = styled (Avatar)`background-color: ${ (props) => {
    return stringToColor (props.alt)
} };`

let stringToColor = (stringInput) => {
    let stringUniqueHash = [...stringInput].reduce ((acc, char) => {
        return char.charCodeAt (0) + ((acc << 5) - acc)
    }, 0)

    return `hsl(${ stringUniqueHash % 360 }, 95%, 35%)`
}

let getAvatar = (displayName) => {
    let str = ``
    let words = displayName.split (/[\s.]+/)

    for (const word of words) {
        str = str.concat (isNaN (word[0]) ? word[0] : ``)
    }
    return str.substring (0, 2).toUpperCase ()
}